import { css } from '@emotion/core';
import { variables, media, aNormalize } from '@domain-group/fe-brary';
import { typography } from '@domain-group/fe-co-allhomes-design-system';
import { expandClickZone } from '../common.style';
var colour = variables.colour,
  font = variables.font;
var headingS = typography.headingS,
  body = typography.body,
  bodySmall = typography.bodySmall,
  bodySmallBold = typography.bodySmallBold,
  bodyBold = typography.bodyBold;
export var listingCard = /*#__PURE__*/css("position:relative;display:flex;flex-direction:column;background-color:", colour.white, ";color:", colour.neutral700, ";text-align:left;width:242px;", media('>=desktop'), "{width:300px;}");
export var image = /*#__PURE__*/css("object-fit:cover;width:242px;height:190px;", media('>=desktop'), "{width:300px;height:225px;}");
export var infoSection = /*#__PURE__*/css("padding-top:10px;margin-bottom:5px;display:flex;flex-direction:row;justify-content:space-between;", media('>=tablet'), "{margin-bottom:2px;}");
export var listingInfo = {
  name: "1fl69p0",
  styles: "padding-bottom:5px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;"
};

// Really we shouln't be using `headingFontFamily` (Proxima Nova) on regular pages,
// but that's how it was originally designed.
export var price = /*#__PURE__*/css(headingS, " font-family:", font.headingFontFamily, ";");
export var addressContainer = /*#__PURE__*/css(aNormalize, " display:flex;flex-direction:column;text-decoration:none;", bodySmall, " line-height:18px;", expandClickZone, " ", media('>=tablet'), "{", body, " line-height:24px;}", media('>=desktop'), "{flex-direction:row;flex-wrap:wrap;}");
export var addressLine = /*#__PURE__*/css("display:block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;", media('>=tablet'), "{margin-bottom:4px;}");
export var featureGroup = /*#__PURE__*/css("display:flex;flex-direction:row;gap:10px;", bodySmallBold, " line-height:18px;", media('>=tablet'), "{", bodyBold, " line-height:18px;}");
export var feature = {
  name: "1j52cd2",
  styles: "display:flex;gap:5px;"
};
export var agentInfo = {
  name: "776891",
  styles: "display:flex;flex-direction:column;align-items:flex-end;padding-top:10px;gap:5px;"
};
export var agentPhoto = {
  name: "fhbt6x",
  styles: "width:36px;height:36px;"
};
export var agentRight = {
  name: "1hd8nx",
  styles: "display:inline-block;line-height:1em;text-align:left;"
};
export var agentName = {
  name: "13o7eu2",
  styles: "display:block;"
};
export var agencyLogo = {
  name: "146faue",
  styles: "max-width:75px;max-height:25px;object-fit:contain;"
};